import { LightSwitchIcon } from './LightSwitchIcon';

/**
 * author: Matthias de Baat
 * id 647E0001-A60B-4D74-B127-BF522712922F
 * name light-switch
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/light-switch.svg
 * tags
 * - Home Automation 
 */
export const RockerSwitchIcon = LightSwitchIcon;
export default RockerSwitchIcon